import React from "react";
import Right from "../../Images/RightSvg.svg";

const Effert = () => {
  const sections = [
    {
      title: "Data entry modules",
      items: [
        "Deductors, Deductees, Employees",
        "TDS & TCS Challan details",
        "Deductee-wise break-up of challans",
      ],
    },
    {
      title: "Auto Generation",
      items: [
        "E-TDS FVU file & form 27A",
        "TDS Certificates (16, 16A, 27D)",
        "Deductee-wise break-up of challans",
      ],
    },
    {
      title: "Import / Export facility",
      items: [
        ".tds file & .txt file",
        "Excel Sheets",
        "Export Salary Data to EasyTAX",
      ],
    },
  ];

  return (
    <div>
      <div className="text-center mb-10">
        <p className="mb-0 text-black text-4xl font-bold">
          Stay compliant{" "}
          <span
            className="font-extrabold"
            style={{
              backgroundImage:
                "linear-gradient(120deg, #686bff 0%, #00b812 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            Effortlessly
          </span>{" "}
          with EasyTDS
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 p-3 gap-x-4 gap-y-5 sm:gap-y-0">
        {sections.map(({ title, items }) => (
          <div
            key={title}
            className="bg-[#b5d0ff] bg-opacity-20 p-5 border-2 border-[#b5d0ff] rounded-xl duration-200 hover:shadow-2xl"
          >
            <p className="mb-5 text-black text-2xl font-bold">{title}</p>
            <div className="space-y-2">
              {items.map((item) => (
                <div key={item} className="flex items-start">
                  <img src={Right} className="mt-[6px] mr-1" alt="" />
                  <p className="mb-0 text-black text-lg font-medium">{item}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Effert;
